import React, { useState, useEffect, useRef } from "react"

/** start SupplierDetails */
import { useLocation } from "@reach/router"
import SupplierDetails from "../../supplierDetails/supplierDetails.js";
/** end SupplierDetails */
import { isEmpty } from "lodash"
import ObjectInfo from "../../clients/SportObjectsSearch/ObjectInfo/ObjectInfo.js"

import "./Tariffs.scss"

import { useTranslation } from "react-i18next"
import filtersByCountry from "../../../utils/filters2.json"
import yesIcon from "./images/check-yes.svg"
import noIcon from "./images/check-no.svg"
import region from "../../../images/levels/region.png"
import silver from "../../../images/levels/silver.png"
import gold from "../../../images/levels/gold.png"
import platinum from "../../../images/levels/platinum.png"
import vip from "../../../images/levels/vip.png"

/** start SupplierDetails */
const MAP_STATE_CENTER_STORAGE = (country) =>
  "suppliersv2_map_state_center" + country
const MAP_STATE_SUBSCRIPTION_STORAGE = (country) =>
  "suppliersv2_map_state_subscription_" + country
const MAP_STATE_TAG_STORAGE = "suppliersv2_map_state_tag"
const MAP_STATE_ACTIVITY_STORAGE = "suppliersv2_map_state_activity"
/** end SupplierDetails */
function Tariffs({ goToForm, titleRu, statistics, statusOpenModal, country }) {
  const { t } = useTranslation()
  const language = country

  /** start SupplierDetails */
  const modalRef = useRef()
  const { pathname } = useLocation();
  /** end SupplierDetails */

  const STRONG_TAG = {
    strongTagStart: "<strong>",
    strongTagEnd: "</strong>",
  };

  const { supplier, activity, suppliers, cities, activities_subscriptions, activities_byCities } =
    statistics
  const tariffsIcons = {
    region: region,
    silver: silver,
    gold: gold,
    platinum: platinum,
    vip: vip,
  }
  const tariffsData = {
    by: [
      {
        name: "Regional",
        level: "region",
      },
      {
        name: "Silver",
        level: "silver",
      },
      {
        name: "Gold",
        level: "gold",
      },
      {
        name: "Platinum",
        level: "platinum",
      },
    ],
    am: [
      {
        name: "Silver",
        level: "silver",
      },
      {
        name: "Gold",
        level: "gold",
      },
      {
        name: "Platinum",
        level: "platinum",
      },
      {
        name: "VIP",
        level: "vip",
      },
    ],
    cy: [
      {
        name: "Silver",
        level: "silver",
      },
      {
        name: "Gold",
        level: "gold",
      },
      {
        name: "Platinum",
        level: "platinum",
      },
    ],
    ru: [
      {
        name: "Silver",
        level: "silver",
      },
      {
        name: "Gold",
        level: "gold",
      },
      {
        name: "Platinum",
        level: "platinum",
      },
    ],
    ua: [
      {
        name: "Silver",
        level: "silver",
      },
      {
        name: "Gold",
        level: "gold",
      },
      {
        name: "Platinum",
        level: "platinum",
      },
    ],
    lt_en: [],
    lt_lt: [],
    lt: [
      {
        name: "Gold",
        level: "gold",
      },
      {
        name: "Platinum",
        level: "platinum",
      },
      {
        name: "VIP",
        level: "vip",
      },
    ],
    en: [],
  }

  /** start SupplierDetails */
  const configurableFilters = filtersByCountry.countries[country]
  const defaultFilters = {
    subscription: configurableFilters.defaults.subscription,
    city: configurableFilters.defaults.city,
    location: filtersByCountry.location[configurableFilters.defaults.city],
    zoom: filtersByCountry.zoom[configurableFilters.defaults.city],
  }
  const emptyMapFilters = {
    subscription: [],
    city: [],
    tag: [],
    activity: [],
    zoom: defaultFilters.zoom,
    location: defaultFilters.location,
    defaults: {
      subscription: defaultFilters.subscription,
      city: defaultFilters.city,
    },
    dictionary: {
      activity: {},
      tag: {},
      subscription: {},
      city: {},
    },
  }
  /** end SupplierDetails */

  const [isOpen, setIsOpen] = useState("" !== statusOpenModal)
  const [isObjects, setIsObjects] = useState("objects" === statusOpenModal)
  const [isActivities, setIsActivities] = useState(
    "activities" === statusOpenModal
  )

  /** start SupplierDetails */
  const [activeSupplier, setActiveSupplier] = useState(null)
  const isBrowser = () => typeof window !== "undefined"
  const setupMinimumEmptyFilters = () => {
    const getStorageCity = () => {
      const storageCity = isBrowser()
        ? localStorage.getItem(MAP_STATE_CENTER_STORAGE(country))
        : defaultFilters.city
      if (!storageCity) {
        return defaultFilters.city
      }
      return String(storageCity).toLowerCase()
    }
    const makeMinimumFilter = () => {
      let subscription = isBrowser()
        ? localStorage.getItem(MAP_STATE_SUBSCRIPTION_STORAGE(country))
        : defaultFilters.subscription
      if (!subscription) {
        subscription = defaultFilters.subscription
      }
      const city = getStorageCity()

      return {
        subscription: String(subscription).toLowerCase(),
        city,
        country,
        language,
        tag: [],
        activity: [],
      }
    }
    const minimum = makeMinimumFilter()

    const makeEmptyFilter = () => {
      const tags = isBrowser()
        ? localStorage.getItem(MAP_STATE_TAG_STORAGE)
        : ""
      const tagsArray = String(tags)
        .split(":")
        .filter((value) => !!value)
      const storedActivitiesAsStr = isBrowser()
        ? localStorage.getItem(MAP_STATE_ACTIVITY_STORAGE)
        : ""
      const activitiesArray = String(storedActivitiesAsStr)
        .split(":")
        .filter((value) => !!value)

      return Object.assign(
        {
          tag: tagsArray,
          activity: activitiesArray,
        },
        minimum
      )
    }
    const selected = makeEmptyFilter()
    return { emptyFilter: selected }
  }
  const { emptyFilter } = setupMinimumEmptyFilters()
  const [loadedFilters, setLoadedFilters] = useState(emptyMapFilters)
  const selectedFilter = emptyFilter
  /** end SupplierDetails */

  let refHeader = null
  let refArr = []
  let refArrOffset = []

  const translate = (name, value) =>
  loadedFilters.dictionary[name]
    ? loadedFilters.dictionary[name][value]
    : null;
  const handleClickObjects = () => {
    window.location.hash = "#objects"
    setIsObjects(true)
    setIsActivities(false)
    setIsOpen(true)
    document.documentElement.classList.add("overflow_hidden")
  }

  const handleClickActivities = () => {
    window.location.hash = "#activities"
    setIsObjects(false)
    setIsActivities(true)
    setIsOpen(true)
    document.documentElement.classList.add("overflow_hidden")
  }

  const handleClickClose = () => {
    setIsOpen(false)
    setIsActivities(false)
    setIsObjects(false)
    document.documentElement.classList.remove("overflow_hidden")
  }

  const handleScroll = (e) => {
    refArrOffset.forEach((offset, index) => {
      if (e.target.scrollTop > offset) {
        refArr[index].classList.add("sticky")
        refArr[index].parentElement.style.paddingTop =
          refArr[index].clientHeight + "px"
        refArr[index].style.zIndex = 10 + index
      } else if (e.target.scrollTop < offset) {
        refArr[index].classList.remove("sticky")
        refArr[index].parentElement.style.paddingTop = "0px"
        refArr[index].style.zIndex = 1
      }
    })
  }

  /** start SupplierDetails */

  const handleLoadObjects = () => {
    document.documentElement.classList.add("overflow_hidden")
  }

  const handleLoadClose = () => {
    document.documentElement.classList.remove("overflow_hidden")
  }

  /* eslint-disable */
  useEffect(() => {
    if (isOpen) {
      document.documentElement.classList.add("overflow_hidden")
    }
    if (modalRef.current && modalRef.current.doLoadMapFilters) {
      modalRef.current.doLoadMapFilters(emptyFilter)
    }
    return () => {
      // Anything in here is fired on component unmount.
      document.documentElement.classList.remove("overflow_hidden")
    }
  }, [isOpen])

  useEffect(() => {
    if (
      window &&
      window.location
    ) {
      if (
        window.location.search &&
        !activeSupplier
      ) {
        handleClickObjects()
        const params = new URLSearchParams(window.location.search)
        const supplier = Object.fromEntries(params.entries())
        return modalRef.current.doLoadSupplier({
          id: supplier.supplier_id,
          name: supplier.supplier_name,
        })
      } else if(window.hash === '#objects') {
        handleClickObjects()
      } else if(window.hash === '#activities') {
        handleClickActivities()
      } else if (!window.location.search) {
        setActiveSupplier(null)
      }
    }
  })
  /* eslint-enable */
  /** end SupplierDetails */
  /* eslint-disable */
  useEffect(() => {

    refArrOffset =
      (refArr &&
        refArr.map(
          (ref) => ref.parentElement.offsetTop - refHeader.clientHeight
        )) ||
      [];

  }, [refArr, isActivities, isObjects])
  /* eslint-enable */
  const getTariffs = (tariffsData, activity, supplier) => {
    const tariffs = []
    activity.forEach((item) => {
      activity[item.key] = item.value
    })

    supplier.forEach((item) => {
      supplier[item.key] = item.value
    })

    tariffsData.forEach((tariff) => {
      if (!activity[tariff.level]) {
        return
      }
      if (["ru", "en"].indexOf(country) !== -1) {
        tariffs.push({
          name: tariff.name,
          imgUrl: tariffsIcons[tariff.level],
          objectTextsMobile: [""],
          objectTextsDesktop: [
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
          ],

          activityTextsMobile: [
            activity[tariff.level] + "+",
            "",
            "",
            "",
            "",
            "",
          ],
          activityTextsDesktop: [
            `<strong>${t("tariffs.moreWord", {
              number: activity[tariff.level],
            })} </strong> ${t("tariffs.activityWord")}`,
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
          ],
          visitsPerMonth: t("tariffs.visitBlock.content", STRONG_TAG),
          level: tariff.level,
        })
      } else {
        tariffs.push({
          name: tariff.name,
          imgUrl: tariffsIcons[tariff.level],
          objectTextsMobile: [`<strong>${supplier[tariff.level]}+</strong>` + "<br /> "],
          objectTextsDesktop: [
            `<strong>${t("tariffs.moreWord", {
              number: supplier[tariff.level],
            })} ${t("tariffs.sportObjects")}</strong>`,
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
          ],

          activityTextsMobile: [
            `<strong>${activity[tariff.level]}+</strong>`,
            "",
            "",
            "",
            "",
            "",
          ],
          activityTextsDesktop: [
            `<strong>${t("tariffs.moreWord", {
              number: activity[tariff.level],
            })} ${t("tariffs.activityWord")}</strong>`,
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
            "", // Желетально оставлять пустую строку для равномерного распределения
          ],
          visitsPerMonth: t("tariffs.visitBlock.content", STRONG_TAG),
          level: tariff.level,
        })
      }
    })
    return tariffs
  }

  const tariffs = getTariffs(
    tariffsData[country],
    activity.subscription_amount_array,
    supplier.subscription_amount_array
  )

  function capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1)
  }

  function getObjectsForModal(cities, suppliers) {
    const objectsForModal = []
    cities.forEach((city) => {
      const object = {}
      object.name = capitalize(city.value)
      object.places = suppliers.filter((supplier) => {
        return supplier.city.toUpperCase() === city.key.toUpperCase()
      })
      objectsForModal.push(object)
    })
    return objectsForModal
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function getActivitiesForModal(cities, activities){
    activities.forEach((activity) => {
        cities.forEach((city) => {
          if (capitalizeFirstLetter(city.key) === activity.city){
            return activity.city = city.value
          }
        })
    })
    return activities
  }

  const objectsForModal = getObjectsForModal(cities, suppliers)
  const activitiesForModal = getActivitiesForModal(cities,activities_byCities)

  let listIndexes = Object.keys(tariffsData).map((value, index) => index)
  const maxTariffsPerPage = listIndexes.length > 3 ? 3 : listIndexes.length
  if (listIndexes.length !== maxTariffsPerPage) {
    listIndexes = listIndexes.splice(0, maxTariffsPerPage)
  }

  let indexForState = tariffs.length - maxTariffsPerPage

  const [index, setIndex] = useState(indexForState)
  function increase() {
    setIndex(index + 1)
  }
  function decrease() {
    setIndex(index - 1)
  }

  function getTariff(count) {
    let newIndex = index + count
    if (!tariffs[newIndex]) {
      newIndex = newIndex - tariffs.length
    }
    return tariffs[newIndex]
  }

  const Span = ({ number, index }) => {
    const arrayNumbers = []
    while (number > index && arrayNumbers.length < maxTariffsPerPage) {
      index++
      arrayNumbers.push(index)
    }
    const string = arrayNumbers.join(", ")
    return <span>{string}</span>
  }

  /** start SupplierDetails */
  function hideActiveSupplier() {
    setActiveSupplier(null)
    try {
      window.history.pushState(
        { supplier_id: null },
        `Объекты ${translate("city", selectedFilter.city)}, ${translate(
          "subscription",
          selectedFilter.subscription
        )}`,
        `${pathname}`
      )
    } catch (e) {
      console.log(e)
    }
  }
  /** end SupplierDetails */

  return (
    <section className="tariffs">
      <h1>{titleRu}</h1>
      {tariffs.length > maxTariffsPerPage ? (
        <div className="slider">
          <button
            disabled={index === 0}
            className="left"
            onClick={decrease}
            aria-label="decrease"
          />
          <Span number={tariffs.length} index={index} />
          <button
            disabled={index + maxTariffsPerPage === tariffs.length}
            className="right"
            onClick={increase}
            aria-label="increase"
          />
        </div>
      ) : null}
      <div className="credit-card-wrapper section-wrapper">
        {listIndexes.map((count, index) => {
          const tariff = getTariff(count)
          if (!tariff) {
            return null
          }
          const { name, imgUrl } = tariff
          return (
            <div key={"card_tariff" + index} className="credit-card-box">
              <img src={imgUrl} alt="" />
              <h3>{name}</h3>
            </div>
          )
        })}
      </div>

      <h3 className="title hide-mobile">{t("tariffs.objectsBlock.title")}</h3>
      <h3 className="title show-mobile">
        {t("tariffs.objectsBlock.titleMobile")}
      </h3>

      <div className="objects-wrapper section-wrapper three-blocks-wrapper">
        {listIndexes.map((count, index) => {
          const tariff = getTariff(count)
          if (!tariff) {
            return null
          }
          const { objectTextsMobile, objectTextsDesktop } = tariff
          let classname = "object-box table-box"

          if (index === 0) classname += " left"
          if (index === 2) classname += " right"

          return (
            <div key={index + "object_box_tariff_"} className={classname}>
              {objectTextsMobile.map((str, innerIndex) => {
                return (
                  <p
                    key={index + " p Objects mobile" + innerIndex}
                    className="show-mobile"
                    dangerouslySetInnerHTML={{ __html: str }}
                  />
                )
              })}
              {objectTextsDesktop.map((str, innerIndex) => {
                return (
                  <p
                    key={index + " p Objects desktop" + innerIndex}
                    className="hide-mobile"
                    dangerouslySetInnerHTML={{ __html: str }}
                  />
                )
              })}
              <div
                className="link-to-all hide-mobile"
                onClick={handleClickObjects}
                onChange={()=>{}}
                aria-hidden="true"
              >
                {" "}
                {t("tariffs.linkToAll")}
              </div>
            </div>
          )
        })}

        <div
          className="link-to-all show-mobile left right"
          onClick={handleClickObjects}
          onChange={()=>{}}
          aria-hidden="true"
        >
          {t("tariffs.linkToAll")}
        </div>
      </div>

      <h3 className="title">{t("tariffs.activitiesBlock.title")}</h3>

      <div className="activities-wrapper section-wrapper three-blocks-wrapper">
        {listIndexes.map((count, index) => {
          const tariff = getTariff(count)
          if (!tariff) {
            return null
          }
          const { activityTextsMobile, activityTextsDesktop } = tariff
          let classname = "activity-box table-box"

          if (index === 0) classname += " left"
          if (index === 2) classname += " right"

          return (
            <div key={index + " activity"} className={classname}>
              {activityTextsMobile.map((str, innerIndex) => {
                return (
                  <p
                    key={index + " p Activity Mobile" + innerIndex}
                    className="show-mobile"
                    dangerouslySetInnerHTML={{ __html: str }}
                  />
                )
              })}
              {activityTextsDesktop.map((str, innerIndex) => {
                return (
                  <p
                    key={index + " p Activity desktop" + innerIndex}
                    className="hide-mobile"
                    dangerouslySetInnerHTML={{ __html: str }}
                  />
                )
              })}
              <div
                className="link-to-all hide-mobile"
                onClick={handleClickActivities}
                onChange={()=>{}}
                aria-hidden="true"
              >
                {t("tariffs.linkToAll")}
              </div>
            </div>
          )
        })}
        <div
          className="link-to-all show-mobile left right"
          onClick={handleClickActivities}
          onChange={()=>{}}
          aria-hidden="true"
        >
          {t("tariffs.linkToAll")}
        </div>
      </div>

      <h3 className="title hide-mobile">{t("tariffs.visitBlock.title")}</h3>
      <h3 className="title show-mobile">
        {t("tariffs.visitBlock.titleMobile")}
      </h3>

      <div className="visits-per-month section-wrapper hide-mobile three-blocks-wrapper">
        {listIndexes.map((count, index) => {
          const tariff = getTariff(count)
          if (!tariff) {
            return null
          }
          const { visitsPerMonth } = tariff
          let classname = "visits-box table-box"

          if (index === 0) classname += " left"
          if (index === 2) classname += " right"

          return (
            <div key={index + " visits"} className={classname}>
              <p dangerouslySetInnerHTML={{ __html: visitsPerMonth }} />
            </div>
          )
        })}
      </div>

      <div className="visits-per-month section-wrapper table-box smooth-corners show-mobile">
        <p dangerouslySetInnerHTML={{ __html: t("tariffs.visitBlock.content", STRONG_TAG) }} />
      </div>

      <h3 className="title">{t("tariffs.cancellationBlock.title")}</h3>

      <div className="cancellation-period section-wrapper hide-mobile smooth-corners three-blocks-wrapper">
        {listIndexes.map((count, index) => {
          const tariff = getTariff(count)
          if (!tariff) {
            return null
          }
          const { name } = tariff
          let classname = "cancell-box table-box"

          if (index === 0) classname += " left"
          if (index === 2) classname += " right"

          return (
            <div key={name + Math.random()} className={classname}>
              <p>
                <strong>{t("tariffs.cancellationBlock.content")}</strong>
              </p>
            </div>
          )
        })}
      </div>

      <div className="cancellation-period section-wrapper table-box smooth-corners show-mobile">
        <p>
          <strong>{t("tariffs.cancellationBlock.content")}</strong>
        </p>
      </div>

      <h3 className="title show-mobile">{t("tariffs.orderButton")}</h3>

      <div className="order-section section-wrapper">
        {listIndexes.map((count, index) => {
          const tariff = getTariff(count)
          if (!tariff) {
            return null
          }
          const { name } = tariff
          let classname = "btn btn-order show-mobile"

          if (index === 0) classname += " left-both"
          if (index === 2) classname += " right-both"

          return (
            <React.Fragment key={index}>
              <button
                type="button"
                className={classname}
                onClick={() => goToForm(name)}
              >
                <p>{name}</p>
              </button>
              <button
                type="button"
                className="btn btn-order hide-mobile"
                onClick={() => goToForm(name)}
              >
                <p>{t("tariffs.orderButton")}</p>
              </button>
            </React.Fragment>
          )
        })}
      </div>

      {isOpen && (
        <div className="modal">
          <header
            className="header menu-open  modal-header"
            ref={(ref) => {
              refHeader = ref
            }}
          >
            <div className="modal-menu">
              <span
                className={isObjects ? "selected" : ""}
                onClick={handleClickObjects}
                onChange={()=>{}}
                aria-hidden="true"
              >
                {t("tariffs.objectsBlock.titleMobile")}
              </span>
              <span
                className={isActivities ? "selected" : ""}
                onClick={handleClickActivities}
                onChange={()=>{}}
                aria-hidden="true"
              >
                {t("tariffs.activitiesBlock.title")}
              </span>
            </div>
            <button className="menu" onClick={handleClickClose} aria-label="menu" />
          </header>

          <div className="modal-body" onScroll={handleScroll}>
            {" "}
            {isObjects && (
              <div>
                {objectsForModal.map((city, index) => {
                  const { name, places } = city
                  return (
                    <div className="city" key={index}>
                      {index === 0 ? (
                        <div
                          className="table-row first-row"
                          ref={(ref) => {
                            refArr.push(ref)
                            return true
                          }}
                        >
                          <h3 className="title">{name}</h3>
                          <div className="levels">
                            {listIndexes.map((count,i) => {
                              const tariff = getTariff(count)
                              if (!tariff) {
                                return null
                              }
                              const { name } = tariff
                              return <p className="level-title" key={i}>{name}</p>
                            })}
                          </div>
                        </div>
                      ) : (
                        <div
                          className="table-row "
                          ref={(ref) => {
                            refArr.push(ref) // ДОБАВИТЬ
                            return true
                          }}
                        >
                          <h3 className="title">{name}</h3>
                          <div className="levels secondary">
                            {listIndexes.map((count,i) => {
                              const tariff = getTariff(count)
                              if (!tariff) {
                                return null
                              }
                              const { name } = tariff
                              return <p className="level-title" key={i}>{name}</p>
                            })}
                          </div>
                        </div>
                      )}

                      {places.map((place, index2) => {
                        // subscription
                        const { name } = place

                        let classnameLeft = "name table-cell"
                        let classnameRight = "table-cell"

                        if (index2 === 0) {
                          classnameLeft += " left-top"
                          classnameRight += " right-top"
                        }

                        if (index2 === places.length - 1) {
                          classnameLeft += " left-bottom  "
                          classnameRight += " right-bottom"
                        }

                        return (
                          <div className="table-row" key={index2}>
                            <p className={`supplier ${classnameLeft}`}
                            onClick={()=> modalRef.current.doLoadSupplier(place)}
                            onChange={()=>{}}
                            aria-hidden="true">{name}</p>
                            <div className="levels">
                              {listIndexes.map((count, index3) => {
                                const tariff = getTariff(count)
                                if (!tariff) {
                                  return null
                                }
                                const tariffLevel = tariff.level
                                const isTrue =
                                  place.subscription.includes(tariffLevel)

                                return (
                                  <p
                                    className={
                                      index3 === 2
                                        ? classnameRight
                                        : "table-cell"
                                    }
                                    key={index3}
                                  >
                                    <img
                                      src={(isTrue && yesIcon) || noIcon}
                                      alt=""
                                    />
                                  </p>
                                )
                              })}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )
                })}
              </div>
            )}
            {isActivities && (
              <div>
                {activitiesForModal.map(({city, activities} , index) => {
                 const cityName = city
                 return (
                   <div className="city" key={index}>
                     {index === 0 ? (
                       <div
                         className="table-row first-row"
                         ref={(ref) => {
                           refArr.push(ref)
                           return true
                         }}
                       >
                         <h3 className="title">{cityName}</h3>
                         <div className="levels">
                           {listIndexes.map((count,i) => {
                             const tariff = getTariff(count)
                             if (!tariff) {
                               return null
                             }
                             const { name } = tariff
                             return <p className="level-title" key={i}>{name}</p>
                           })}
                         </div>
                       </div>
                     ) : (
                       <div
                         className="table-row "
                         ref={(ref) => {
                           refArr.push(ref)
                           return true
                         }}
                       >
                         <h3 className="title">{cityName}</h3>
                         <div className="levels secondary">
                           {listIndexes.map((count,i) => {
                             const tariff = getTariff(count)
                             if (!tariff) {
                               return null
                             }
                             const { name } = tariff
                             return <p className="level-title" key={i}>{name}</p>
                           })}
                         </div>
                       </div>
                     )}

                     {
                      activities.map(({name , subscription}, index2) =>{
                        const activityName = name
                        let classnameLeft = "name table-cell"
                        let classnameRight = "table-cell"

                       if (index2 === 0) {
                         classnameLeft += " left-top"
                         classnameRight += " right-top"
                       }

                       if (index2 === activities.length - 1) {
                         classnameLeft += " left-bottom  "
                         classnameRight += " right-bottom"
                       }
                       return (
                        <div className="table-row" key={index2}>
                          <p className={`supplier ${classnameLeft}`}
                          aria-hidden="true">{activityName}</p>
                          <div className="levels">
                            {listIndexes.map((count, index3) => {
                              const tariff = getTariff(count)
                              if (!tariff) {
                                return null
                              }
                              const tariffLevel = tariff.level
                              const isTrue = subscription.includes(tariffLevel)

                              return (
                                <p
                                  className={
                                    index3 === 2
                                      ? classnameRight
                                      : "table-cell"
                                  }
                                  key={index3}
                                >
                                  <img
                                    src={(isTrue && yesIcon) || noIcon}
                                    alt=""
                                  />
                                </p>
                              )
                            })}
                          </div>
                        </div>
                      )
                      })
                     }
                   </div>
                 )
               })}
              </div>
            )}
          </div>
        </div>
      )}
      <SupplierDetails
        ref={modalRef}
        activeSupplier={activeSupplier}
        emptyMapFilters={emptyMapFilters}
        setActiveSupplier={setActiveSupplier}
        setLoadedFilters={setLoadedFilters}
        handleClickClose={handleLoadClose}
        handleClickObjects={handleLoadObjects}
      />
      {isObjects && !isEmpty(activeSupplier) && (
          <ObjectInfo
            key={activeSupplier.id}
            startRef={null}
            close={hideActiveSupplier}
            supplier={activeSupplier}
            loadedFilters={loadedFilters}
            subscription={selectedFilter.subscription}
          />
        )}
    </section>
  )
}

export default Tariffs
